"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetTranslationsClientRaw = exports.WidgetTranslationsClient = void 0;
class WidgetTranslationsClient {
    constructor(adapter) {
        this.adapter = adapter;
        this.raw = new WidgetTranslationsClientRaw(this.adapter);
    }
    getDefaults(lang, options) {
        return this.adapter.request('get', `/widget/translations/lang/${lang}/defaults`, null, null, options).then(toData);
    }
    getVersion(options) {
        return this.adapter.request('get', '/widget/translations/version', null, null, options).then(toData);
    }
}
exports.WidgetTranslationsClient = WidgetTranslationsClient;
class WidgetTranslationsClientRaw {
    constructor(adapter) {
        this.adapter = adapter;
    }
    getDefaults(lang, options) {
        return this.adapter.request('get', `/widget/translations/lang/${lang}/defaults`, null, null, options);
    }
    getVersion(options) {
        return this.adapter.request('get', '/widget/translations/version', null, null, options);
    }
}
exports.WidgetTranslationsClientRaw = WidgetTranslationsClientRaw;
// helpers
function toData(res) {
    return res.data;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2lkZ2V0VHJhbnNsYXRpb25zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FwaXMvd2lkZ2V0VHJhbnNsYXRpb25zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVBLE1BQWEsd0JBQXdCO0lBR3BDLFlBQW1CLE9BQXVCO1FBQXZCLFlBQU8sR0FBUCxPQUFPLENBQWdCO1FBQ3pDLElBQUksQ0FBQyxHQUFHLEdBQUcsSUFBSSwyQkFBMkIsQ0FBQyxJQUFJLENBQUMsT0FBTyxDQUFDLENBQUE7SUFDekQsQ0FBQztJQUVELFdBQVcsQ0FBQyxJQUF3QixFQUFFLE9BQVc7UUFDaEQsT0FBTyxJQUFJLENBQUMsT0FBTyxDQUFDLE9BQU8sQ0FBQyxLQUFLLEVBQUUsNkJBQTZCLElBQUksV0FBVyxFQUFFLElBQUksRUFBRSxJQUFJLEVBQUUsT0FBTyxDQUFDLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFBO0lBQ25ILENBQUM7SUFFRCxVQUFVLENBQUMsT0FBVztRQUNyQixPQUFPLElBQUksQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDLEtBQUssRUFBRSw4QkFBOEIsRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLE9BQU8sQ0FBQyxDQUFDLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQTtJQUNyRyxDQUFDO0NBQ0Q7QUFkRCw0REFjQztBQUVELE1BQWEsMkJBQTJCO0lBQ3ZDLFlBQW1CLE9BQXVCO1FBQXZCLFlBQU8sR0FBUCxPQUFPLENBQWdCO0lBQUcsQ0FBQztJQUU5QyxXQUFXLENBQUMsSUFBd0IsRUFBRSxPQUFXO1FBQ2hELE9BQU8sSUFBSSxDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUMsS0FBSyxFQUFFLDZCQUE2QixJQUFJLFdBQVcsRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLE9BQU8sQ0FBQyxDQUFBO0lBQ3RHLENBQUM7SUFFRCxVQUFVLENBQUMsT0FBVztRQUNyQixPQUFPLElBQUksQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDLEtBQUssRUFBRSw4QkFBOEIsRUFBRSxJQUFJLEVBQUUsSUFBSSxFQUFFLE9BQU8sQ0FBQyxDQUFBO0lBQ3hGLENBQUM7Q0FDRDtBQVZELGtFQVVDO0FBRUQsVUFBVTtBQUVWLFNBQVMsTUFBTSxDQUFDLEdBQUc7SUFDbEIsT0FBTyxHQUFHLENBQUMsSUFBSSxDQUFBO0FBQ2hCLENBQUMifQ==